import React from 'react';
import PropTypes from 'prop-types';
import AUIButton from '@ancert/aui-button';
import AUIButtonsGroup from '@ancert/aui-buttons-group';

import './ValidacionMovil.scss';

/**
 * @component
 * @param {Object} props - Props del componente
 * @returns {React.ReactElement}
 */
const ValidacionMovil = ({
  onClose,
  handleValidateSignature,
  handleDownloadDocument,
  descargarJustificanteMobil,
  handleShowHelp,
  validationLoading,
  urlDescargaCopiaFirmada,
  dataModal,
}) => (
  <div className="container ">
    <div className="title">No es posible mostrar la copia en dispositivos móviles</div>
    <div className="text--movil">Por favor, selecciona una de las siguientes acciones.</div>
    <AUIButtonsGroup>
      <AUIButton className="button-consultar" label="Cancelar" mode="tertiary" onClick={onClose} />
      <AUIButton
        className="button-consultar"
        label="Descargar"
        mode="secondary"
        onClick={handleDownloadDocument}
        disabled={!urlDescargaCopiaFirmada}
      />
      <AUIButton
        className="button-consultar"
        label="Validar firma"
        mode="secondary"
        onClick={handleValidateSignature}
        disabled={validationLoading}
      />
      <AUIButton className="button-consultar" label="Ver ayuda" mode="secondary" onClick={handleShowHelp} />
      <AUIButton
        className="button-consultar"
        label="Descargar justificante"
        mode="primary"
        onClick={descargarJustificanteMobil}
        disabled={!dataModal}
      />
    </AUIButtonsGroup>
  </div>
);

ValidacionMovil.propTypes = {
  onClose: PropTypes.func.isRequired,
  handleValidateSignature: PropTypes.func.isRequired,
  handleDownloadDocument: PropTypes.func.isRequired,
  descargarJustificanteMobil: PropTypes.func.isRequired,
  handleShowHelp: PropTypes.func.isRequired,
  validationLoading: PropTypes.bool.isRequired,
  urlDescargaCopiaFirmada: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  dataModal: PropTypes.string,
};

ValidacionMovil.defaultProps = {
  urlDescargaCopiaFirmada: false,
  dataModal: null,
};

export default ValidacionMovil;
